const SpacerSchema = (props) => ({
  title: 'Espaçador',
  fieldsets: [{ id: 'default', title: 'Tamanho', fields: ['size'] }],
  properties: {
    size: {
      title: 'Tamanho',
      description: 'Altura do espaço vertical.',
      choices: [
        ['xs', 'Mínimo (12px)'],
        ['s', 'Pequeno (20px)'],
        ['m', 'Médio (32px)'],
        ['g', 'Grande (64px)'],
        ['xg', 'Extra grande (80px)'],
        ['2xg', 'Duplo extra grande (96px)'],
      ],
      default: 'm',
    },
  },
  required: [],
});
export default SpacerSchema;
